import React, { useEffect, useState } from "react";
import styles from "@/pages/css/CreateProjectPage.module.css";

import { useTranslation } from "react-i18next";
import { InputField } from "@/components/inputFields/inputFields";
import TextField from "@/components/inputFields/TextFeild";
import { UploadFilesTableData, FilesTypes } from "@/types/file";
import UploadFilesTable from "@/components/tables/UploadFilesTable";
import { ModelView } from "@/components/files/ModelView";
import { CreateAlternativeRequest } from "@/types/alternative";
import { UploadAndViewFiile } from "@/components/cards/UploadAndViewFiile";
import { CreateAlternativeFields } from "./CreateAlternativeFields";

export const CreateAlternative: React.FC<{
    onChange: (data: CreateAlternativeRequest) => void;
    data: CreateAlternativeRequest | undefined;
    setStepsCompleted: React.Dispatch<React.SetStateAction<boolean[]>>;
    alternativeFiles: UploadFilesTableData[];
    onUploadFile: (type: FilesTypes, file: File) => void;
    fieldsCompleted: boolean;
    disabled: boolean;
    setFieldsCompleted: React.Dispatch<React.SetStateAction<boolean>>;
}> = ({ onChange, data, setStepsCompleted, alternativeFiles, onUploadFile, fieldsCompleted, setFieldsCompleted, disabled }) => {
    const { t } = useTranslation("CreateProjectPage");
    const [modelFile, setModelFile] = useState<File | null>(null);
    const [modelFileUrl, setModelFileUrl] = useState<string | null>(null);

    const handleChange = (newData: CreateAlternativeRequest) => {
        onChange(newData);
        setStepsCompleted(prev => {
            const newSteps = [...prev];
            newSteps[1] = Boolean(newData.name) && fieldsCompleted && 
                         ((newData.residential_area_planned !== undefined && newData.residential_area_planned !== null) || 
                          (newData.residental_unit_area_planned !== undefined && newData.residental_unit_area_planned !== null) ||
                          (!newData.residential_area_planned && !newData.residental_unit_area_planned));
            return newSteps;
        });
    }

    useEffect(() => {
        if (!data) return;
        
        setStepsCompleted(prev => {
            const newSteps = [...prev];
            newSteps[1] = Boolean(data.name) && 
                         fieldsCompleted && 
                         ((data.residential_area_planned !== undefined && data.residential_area_planned !== null) || 
                          (data.residental_unit_area_planned !== undefined && data.residental_unit_area_planned !== null) ||
                          (!data.residential_area_planned && !data.residental_unit_area_planned));
            return newSteps;
        });
    }, [data, fieldsCompleted]);

    useEffect(() => {
        if (alternativeFiles) {
            const modelFile = alternativeFiles.find(file => file.type === "3dmodel")?.file;
            if (typeof modelFile === "string") {
                setModelFile(null);
                setModelFileUrl(modelFile);
            } else {
                setModelFile(modelFile as File);
                setModelFileUrl(null);
            }
        }
    }, [alternativeFiles]);

    if (!data) return null;

    return <div className={styles.pahseContainerOnePage}>
        <div className={styles.row}>
            <div className={styles.titleElementComponent}>
                <div className={styles.inputTitle}>{t("model")}</div>
                {modelFileUrl ? <UploadAndViewFiile fileUrl={modelFileUrl} type="3dmodel" /> : <UploadAndViewFiile file={modelFile} type="3dmodel" />}
            </div>
            <div className={styles.fileDataContainer}>
                <div className={styles.titleElementComponent}>
                    <div className={styles.inputTitle}>{t("alternativeName")}</div>
                    <InputField small={true} inputType="text" data={String(data.name || '')} setData={(value) => handleChange({ ...data, name: String(value || '') })} id="alternativeName" showError={false} />
                </div>
                <div className={styles.titleElementComponent}>
                    <div className={styles.inputTitle}>{t("alternativeDescription")}</div>
                    <TextField id="alternativeDescription" placeholder="" text={data.description || ''} setText={(value) => handleChange({ ...data, description: value })} size="small" showCharCount={false}/>
                </div>
            </div>
        </div>
        <div className={`${styles.rowContainerOnePage} mt-[10px]`}>
            <div className={styles.titleElementComponent}>
                <div className={styles.inputTitle}>{t("files")}</div>
                <div className={styles.filesContainer}>
                    <UploadFilesTable
                        dataTestId="alternativeFiles"
                        files={alternativeFiles}
                        onUploadFile={onUploadFile}
                        showFull={true}
                        rows={1}
                    />
                </div>
            </div>
        </div>
        <CreateAlternativeFields onChange={handleChange} data={data} setStepsCompleted={setFieldsCompleted} disabled={false} />
    </div>;
};
